//一个一个导入导出
export var arr = ['a', 'b', 'c', 'd']   //导出数组
export var stringName = 'I is xuqian'   //导出字符串
export var obj = { name: 'xq', age: '18', id: 1 }  //导出对象
export function way() {   //导出方法
    return '方法'
}